import { render, staticRenderFns } from "./DefaultServicesList.vue?vue&type=template&id=2f3d5ae8&scoped=true"
import script from "./DefaultServicesList.vue?vue&type=script&lang=js"
export * from "./DefaultServicesList.vue?vue&type=script&lang=js"
import style0 from "./DefaultServicesList.vue?vue&type=style&index=0&id=2f3d5ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d5ae8",
  null
  
)

export default component.exports